<div [ngClass]="{ 'expanded': event.favourited, 'with-favourite': showHoverFavoriteToggle, 'with-markets': showMarkets }">
    <a class="tree-event-wrapper" [href]="eventUrl" [msRemoveHref]="shouldRemoveHref" (click)="selectEvent()">
        @if (showHoverFavoriteToggle) {
            <div class="favourite-details">
                <ms-favourite-event-toggle [event]="event.data" />
            </div>
        }
        <ms-tree-event-detail [event]="event.data" [updatedFavourites]="updatedFavourites" [hideFavouriteIcon]="hideFavourites" />
        <ms-grid-scoreboard [event]="event.data" />
    </a>
    @if (showMarkets) {
        <ms-tree-market [event]="event.data" [leftNavType]="leftNavType" />
    }
</div>
